module.exports = __webpack_public_path__ + "static/media/ussf90mintext-medium.384cb16d.ttf";